import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBPHXEu9zY8LO0SUrkT2ISqdXDZpcgk31E",
  authDomain: "wealthquota.firebaseapp.com",
  projectId: "wealthquota",
  storageBucket: "wealthquota.firebasestorage.app",
  messagingSenderId: "983911519144",
  appId: "1:983911519144:web:92783b54dbe4f5e7e4c39d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;

// For debugging
console.log('Firebase Config:', {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY ? 'exists' : 'missing',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ? 'exists' : 'missing',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID ? 'exists' : 'missing'
}); 